import { useRouter } from '@/i18n/routing';
import { SearchProduct } from '@winelivery-org/wl-client-sdk-js/dist/models/search';
import { Button } from '../../../../../components/design-system';
import { Hearth as IconHearth } from '../../../../../components/icons';
import NoUserError from '../../components/errors/NoUserError';
import useProduct from '../../components/hooks/useProduct';

interface Props {
  product: SearchProduct;
}

export default function ButtonWishList({ product }: Props) {
  const router = useRouter();
  const { isInWishList, addToWishList, removeFromWishList } =
    useProduct(product);

  function handleClick() {
    try {
      if (isInWishList) {
        removeFromWishList();
      } else {
        addToWishList();
      }
    } catch (e) {
      if (e instanceof NoUserError) {
        router.push({
          pathname: `/auth/signin`,
          query: {
            redirect: typeof window === 'undefined' ? '' : window.location.href,
          },
        });
      }
    }
  }

  return (
    <Button
      className="shrink-0"
      size="lg"
      variant="icon"
      theme="outline"
      onClick={handleClick}
    >
      <IconHearth className={isInWishList ? 'fill-secondary-light' : ''} />
    </Button>
  );
}
